(function ($) {
  Drupal.behaviors.proHowToBlockFormatterV1 = {
    attach: function (context) {
      var proFormatter = $('.js-pro-how-to-block-tab-container', context);
      var SelectProItem = $('.js-pro-item', proFormatter);
      var proBlockTitle = $('.js-pro-how-to-block-title', proFormatter);

      // Create Pro Block Tab Container
      proBlockTitle.each(function (index, item) {
        var li = $('<li/>');
        var option = $(
          '<option value=tab_item-' + parseInt(index) + '>' + $(this).text() + '</option>'
        );

        $(this).appendTo(li);
        option.appendTo(SelectProItem);
        li.appendTo($('.resp-tabs-list', proFormatter));
      });

      // Create Pro Block SelectBox Container
      if (SelectProItem.length > 0) {
        SelectProItem.selectBox();
        SelectProItem.bind('change', function (e) {
          var selectdItem = $(
            '.js-pro-how-to-block-content[aria-labelledby=' + $(this).val() + ']',
            proFormatter
          );

          if (selectdItem.length > 0) {
            $('.js-pro-how-to-block-content', proFormatter).removeClass('active').hide();
            selectdItem.addClass('active');
            selectdItem.show();
          }
        });
      }

      // Initialize Tab Container
      proFormatter.easyResponsiveTabs();

      // Toggle Suggested Product Container
      $('.js-suggested-product-link', proFormatter).bind('click', function (e) {
        var suggestedProduct = $(this).next('.js-suggested_product', proFormatter);

        suggestedProduct
          .slideToggle(400, function () {
            var $wrapper = $(this);
            var $grid = $('.product-grid--quickshop', $wrapper);
            var bp = Unison.fetch.now().name;

            Drupal.behaviors.productGrid.equalHeights($wrapper);
            $('.js-product-carousel', suggestedProduct).unslick();

            // Initialize Carousel Container
            site.productCarousel.init($wrapper);

            // Initialize Quickshop Container
            Drupal.behaviors.quickshop.initGrid($grid, bp);

            $(window).scrollTo($wrapper, 800, {
              offset: -69,
              axis: 'y'
            });
          })
          .toggleClass('active is-expanded');
      });
      // Toggle Suggested Product
      $('.js-suggested-product-link', proFormatter).on('keydown', function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });
    }
  };
})(jQuery);
